<script lang="ts">
  import { onMount } from 'svelte';
  import Icon from '../../components/Icon.svelte';
  import { fetchReverseLinks, type ReverseLinkGroup } from '../data-tables-api';

  let {
    sourceSlug,
    sourceId,
  }: {
    /** Slug таблиці поточного запису (users / payments / custom-slug). */
    sourceSlug: string;
    /** UUID поточного запису. */
    sourceId: string;
  } = $props();

  let groups = $state<ReverseLinkGroup[]>([]);
  let loading = $state(true);
  let err = $state<string | null>(null);

  onMount(async () => {
    if (!sourceSlug || !sourceId) {
      loading = false;
      return;
    }
    try {
      const r = await fetchReverseLinks(sourceSlug, sourceId);
      groups = r.groups;
    } catch (e) {
      err = e instanceof Error ? e.message : String(e);
    } finally {
      loading = false;
    }
  });

  /** URL для конкретного запису залежно від tableSlug. */
  function hrefFor(tableSlug: string, recordId: string): string {
    if (tableSlug === 'users') return `#/persons/${recordId}`;
    if (tableSlug === 'payments') return `#/payments/${recordId}`;
    return `#/tables/${tableSlug}/${recordId}`;
  }
</script>

{#if !loading}
  <!-- Самодостатня секція: заголовок завжди, далі контент або порожній стан.
       Рендериться як group внизу колонки полів (PersonDetail / CustomRecordDetail). -->
  <div class="space-y-2">
    <div class="text-[9.5px] font-bold uppercase tracking-wider text-[var(--color-text-muted-2)]">
      Зворотньо пов'язані записи
    </div>
    {#if err}
      <div class="text-[10.5px] text-red-600">Не вдалось завантажити: {err}</div>
    {:else if groups.length === 0}
      <div class="text-[11px] text-[var(--color-text-muted)] italic">
        Жоден запис поки не посилається на цей.
      </div>
    {:else}
      {#each groups as g (g.tableSlug + ':' + g.fieldKey)}
        <div class="rounded-lg border border-[var(--color-border-3)] bg-white">
          <div class="px-2.5 py-1.5 border-b border-[var(--color-border-3)] flex items-center gap-1.5">
            <span class="text-[12px]">{g.tableIcon}</span>
            <span class="text-[10px] font-semibold uppercase tracking-wider text-[var(--color-text-muted-2)] truncate">
              {g.tableName} → {g.fieldLabel}
            </span>
            <span class="ml-auto text-[10px] text-[var(--color-text-muted)] tabular-nums">{g.total}</span>
          </div>
          <div class="p-1.5 space-y-1">
            {#each g.records as rec (rec.id)}
              <a
                href={hrefFor(g.tableSlug, rec.id)}
                class="block rounded-md border border-[var(--color-border-3)] bg-white px-2 py-1 no-underline text-[12px] hover:border-[var(--color-pu-2)] hover:bg-[var(--color-bg-3)] transition-colors truncate"
                title="Відкрити запис"
              >
                <Icon name="externalLink" size={11} class="text-[var(--color-pu)] mr-1 inline align-[-1px]" />
                <span class="text-[var(--color-text)]">{rec.label}</span>
              </a>
            {/each}
            {#if g.total > g.records.length}
              <div class="px-2 py-0.5 text-[10px] text-[var(--color-text-muted)]">
                Показано {g.records.length} з {g.total}
              </div>
            {/if}
          </div>
        </div>
      {/each}
    {/if}
  </div>
{/if}
